import React from "react";

const Language = () => {
  return (
    <div>
      <h1>Språk</h1>
      <p>Her er språk.</p>
    </div>
  );
};

export default Language;
